import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    root: {
      textAlign: 'center',
    },

    skeletonTitle: {
      height: 36,
      marginBottom: Spacings.s12,
    },

    skeletonDescription: {
      height: 72,
      marginBottom: Spacings.s24,
    },

    skeletonSquare: {
      width: 140,
      height: 140,
    },

    title: {
      marginBottom: Spacings.s10,
    },

    description: {
      marginBottom: Spacings.s16,
    },

    tabs: {
      marginInline: 'auto',
      marginBottom: Spacings.s32,
      maxWidth: '100%',
      overflowX: 'auto',
      width: 'fit-content',

      '& button': {
        textTransform: 'capitalize',
        marginInline: Spacings.s6,
      },
    },

    carousel: {
      marginInline: 'auto',
    },

    color: {
      borderRadius: CornerRadius.r8,
      marginRight: Spacings.s16,
      height: 140,
      width: 140,
    },
  },
  {
    name: 'colors-by-category',
  },
);

export default useStyles;
